// Generated from the KaizenUI Foundations Figma file by `nx run design-system:generate-tokens`. Do not edit.
// Every value below is a fully resolved literal.

export const tokens = {
  base: {
    size: {
      2: 2,
      4: 4,
      6: 6,
      8: 8,
      10: 10,
      12: 12,
      14: 14,
      16: 16,
      20: 20,
      22: 22,
      24: 24,
      28: 28,
      32: 32,
      36: 36,
      40: 40,
      44: 44,
      48: 48,
      56: 56,
      64: 64,
      72: 72,
      80: 80,
      88: 88,
      96: 96,
      112: 112,
      128: 128,
      negative2: -2,
      negative4: -4,
      negative6: -6,
      negative8: -8,
      negative10: -10,
      negative12: -12,
      negative14: -14,
      negative16: -16,
      negative20: -20,
      negative22: -22,
      negative24: -24,
      negative28: -28,
      negative32: -32,
      negative36: -36,
      negative40: -40,
      negative44: -44,
      negative48: -48,
      negative56: -56,
      negative64: -64,
      negative72: -72,
      negative80: -80,
      negative88: -88,
      negative96: -96,
      negative112: -112,
      negative128: -128,
    },
    typography: {
      fontStack: {
        sansSerif: "Montserrat",
        monospace: "Inconsolata",
        sansSerifDisplay: "Montserrat",
        system: "Montserrat",
      },
      text: {
        size: {
          /** Smallest text size for captions and compact UI elements. */
          xs: 10,
          /** Small body text size for UI as secondary text to body. */
          sm: 12,
          /** Default body text size for UI. */
          md: 14,
          /** Large body text and small titles. */
          lg: 18,
          /** Medium titles and subtitles. */
          xl: 22,
          /** Large titles and page headings. */
          "2xl": 27,
          /** - */
          "3xl": 34,
          /** Display text for hero sections. */
          "4xl": 43,
        },
        lineHeight: {
          /** base.typography.text.lineHeight.tight */
          tight: 1.25,
          /** base.typography.text.lineHeight.snug */
          snug: 1.375,
          /** base.typography.text.lineHeight.normal */
          normal: 1.5,
          /** base.typography.text.lineHeight.relaxed */
          relaxed: 1.625,
          /** base.typography.text.lineHeight.loose */
          loose: 1.75,
        },
        weight: {
          light: 300,
          regular: 400,
          medium: 500,
          semibold: 600,
          bold: 700,
        },
      },
    },
  },
  baseColorLight: {
    color: {
      black: "#000000",
      white: "#ffffff",
      purple: {
        /** brand-primary--dark */
        25: "#fefcfe",
        50: "#fbfafb",
        100: "#f7edf7",
        200: "#edd8ec",
        300: "#debedc",
        400: "#cba0c9",
        500: "#b57fb3",
        /** brand-primary--light */
        600: "#ac6fa9",
        700: "#9a5397",
        /** brand-primary */
        800: "#832a80",
        /** brand-primary--dark */
        900: "#6a2268",
        /** brand-primary--dark */
        950: "#4f194d",
        /** brand-primary--dark */
        975: "#200020",
      },
      neutral: {
        25: "#ffffff",
        50: "#fbfbfb",
        100: "#eeeeee",
        200: "#dadada",
        300: "#c4c4c4",
        400: "#acacac",
        500: "#929292",
        600: "#858585",
        700: "#737373",
        800: "#5d5d5d",
        900: "#464646",
        950: "#2e2e2e",
        975: "#222222",
      },
      blue: {
        /** brand-primary--dark */
        25: "#fafdff",
        50: "#f7fafe",
        100: "#e3f0ff",
        200: "#c3deff",
        300: "#9cc5ff",
        400: "#6fa7f5",
        500: "#3b84e7",
        600: "#0276f2",
        700: "#0066d4",
        800: "#0d53a8",
        900: "#143e75",
        /** brand-primary--dark */
        950: "#15263f",
        /** brand-primary--dark */
        975: "#06162d",
      },
      transparent: "#ffffff00",
      lavender: {
        /** brand-primary--dark */
        25: "#fcfbfd",
        50: "#f9f6fb",
        100: "#eee5f5",
        200: "#dfcced",
        300: "#ceafe4",
        400: "#bb8eda",
        500: "#a56bcb",
        600: "#9a58c3",
        700: "#874aac",
        800: "#6f3c8e",
        900: "#552e6d",
        /** brand-primary--dark */
        950: "#3a1f4b",
        /** brand-primary--dark */
        975: "#2d173b",
      },
      teal: {
        /** brand-primary--dark */
        25: "#f9fefd",
        50: "#f7fbfb",
        100: "#d2fbfa",
        200: "#95f4f3",
        300: "#01e8e8",
        400: "#00c8c9",
        500: "#00a5a5",
        600: "#009899",
        700: "#008383",
        800: "#086969",
        900: "#104c4b",
        /** brand-primary--dark */
        950: "#0e2d2c",
        /** brand-primary--dark */
        975: "#001c1c",
      },
      red: {
        /** brand-primary--dark */
        25: "#fefafa",
        50: "#fdf6f4",
        100: "#fbe3df",
        200: "#f9c7c0",
        300: "#f8a498",
        400: "#f6796a",
        500: "#f13b31",
        600: "#e7000b",
        700: "#c51916",
        800: "#a01d18",
        900: "#791b15",
        /** brand-primary--dark */
        950: "#53130e",
        /** brand-primary--dark */
        975: "#410d09",
      },
      amber: {
        /** brand-primary--dark */
        25: "#fefbf6",
        50: "#fdf8ee",
        100: "#fceccb",
        200: "#fdd98f",
        300: "#ffc107",
        400: "#e0a907",
        500: "#be900a",
        600: "#ad830d",
        700: "#95700e",
        800: "#795b0d",
        900: "#5b440a",
        /** brand-primary--dark */
        950: "#3c2c05",
        /** brand-primary--dark */
        975: "#2d2003",
      },
      yellow: {
        /** brand-primary--dark */
        25: "#fdfcf4",
        50: "#fcf8e8",
        100: "#f6ecb8",
        200: "#edd870",
        300: "#dbc03a",
        400: "#c1a821",
        500: "#a48e10",
        600: "#968100",
        700: "#816f05",
        800: "#6a5b08",
        900: "#504508",
        /** brand-primary--dark */
        950: "#362e06",
        /** brand-primary--dark */
        975: "#292203",
      },
      orange: {
        /** brand-primary--dark */
        25: "#fefbf8",
        50: "#fef6f2",
        100: "#fce6d8",
        200: "#fbccaf",
        300: "#faad79",
        400: "#f7872e",
        500: "#d96e00",
        600: "#c66404",
        700: "#ab5607",
        800: "#8c4607",
        900: "#6b3506",
        /** brand-primary--dark */
        950: "#482204",
        /** brand-primary--dark */
        975: "#381902",
      },
      green: {
        /** brand-primary--dark */
        25: "#f8fdf8",
        50: "#f1fbf1",
        100: "#d5f6d3",
        200: "#a7eda6",
        300: "#80dc80",
        400: "#66c567",
        500: "#50aa52",
        600: "#409d44",
        700: "#3b863d",
        800: "#326d34",
        900: "#265227",
        /** brand-primary--dark */
        950: "#183619",
        /** brand-primary--dark */
        975: "#112911",
      },
      lime: {
        /** brand-primary--dark */
        25: "#fbfcf6",
        50: "#f6f9eb",
        100: "#e5efa9",
        200: "#cddc39",
        300: "#b8c630",
        400: "#a2ae2d",
        500: "#8a9529",
        600: "#7e8727",
        700: "#6d7523",
        800: "#59601c",
        900: "#434915",
        /** brand-primary--dark */
        950: "#2d310c",
        /** brand-primary--dark */
        975: "#222507",
      },
      indigo: {
        /** brand-primary--dark */
        25: "#fbfbfe",
        50: "#f6f7fe",
        100: "#e5e8fb",
        200: "#cbd2fa",
        300: "#aeb8f9",
        400: "#8f9afa",
        500: "#7076fa",
        600: "#615fff",
        700: "#5343f7",
        800: "#4430d5",
        900: "#3329a1",
        950: "#211d6d",
        /** brand-primary--dark */
        975: "#191557",
      },
      magenta: {
        /** brand-primary--dark */
        25: "#fffaff",
        50: "#fef8fd",
        100: "#ffdeff",
        200: "#ffb8ff",
        300: "#ff7eff",
        400: "#ff00ff",
        500: "#d700d8",
        600: "#c700c7",
        700: "#ab05ab",
        800: "#881588",
        900: "#621861",
        /** brand-primary--dark */
        950: "#3a1439",
        /** brand-primary--dark */
        975: "#290428",
      },
      khaki: {
        /** brand-primary--dark */
        25: "#fcfbfa",
        50: "#faf8f6",
        100: "#f0ece5",
        200: "#e3dacc",
        300: "#d5c6af",
        400: "#c3b091",
        500: "#a89575",
        600: "#9a8769",
        700: "#857459",
        800: "#6c5e47",
        900: "#514634",
        /** brand-primary--dark */
        950: "#352e21",
        /** brand-primary--dark */
        975: "#282117",
      },
      slateBlue: {
        /** brand-primary--dark */
        25: "#fbfcfc",
        50: "#f7f8f9",
        100: "#e7ecef",
        200: "#d1dae1",
        300: "#b8c6d0",
        400: "#9db0bc",
        500: "#8398a6",
        600: "#768c9a",
        700: "#647a88",
        800: "#516572",
        900: "#3c4b55",
        /** brand-primary--dark */
        950: "#273137",
        /** brand-primary--dark */
        975: "#1c2429",
      },
      pink: {
        /** brand-primary--dark */
        25: "#fdfbfb",
        50: "#fcf6f6",
        100: "#f7e6e6",
        200: "#f1cecd",
        300: "#ecb1b0",
        400: "#e68f8f",
        500: "#d56e70",
        600: "#c66164",
        700: "#ad5154",
        800: "#8f4144",
        900: "#6d3133",
        /** brand-primary--dark */
        950: "#491f21",
        /** brand-primary--dark */
        975: "#381617",
      },
      cyan: {
        /** brand-primary--dark */
        25: "#fafdfe",
        50: "#f8fafb",
        100: "#e0f3f8",
        200: "#bbe3ef",
        300: "#8ccde0",
        400: "#4fb3cd",
        500: "#2c94b6",
        /** brand-secondary */
        600: "#208aaf",
        700: "#0078a2",
        800: "#02648a",
        900: "#024d6e",
        /** brand-primary--dark */
        950: "#00344f",
        /** brand-primary--dark */
        975: "#000d23",
      },
      pine: {
        /** brand-primary--dark */
        25: "#fbfdfd",
        50: "#f8fafa",
        100: "#e7f1f0",
        200: "#cce0dd",
        300: "#aac9c4",
        400: "#83aea8",
        500: "#579189",
        600: "#3d8980",
        700: "#34776f",
        800: "#2c6059",
        900: "#254541",
        /** brand-primary--dark */
        950: "#1b2927",
        /** brand-primary--dark */
        975: "#0c1918",
      },
    },
  },
  functional: {
    size: {
      borderWidth: {
        default: 1,
        thin: 1,
        thick: 2,
        thicker: 4,
      },
      space: {
        xxsmall: 2,
        xsmall: 4,
        small: 6,
        medium: 8,
        large: 12,
        xlarge: 16,
        xxlarge: 24,
        default: 8,
      },
      breakpoint: {
        xsmall: 320,
        small: 480,
        medium: 768,
        large: 1024,
        xlarge: 1440,
      },
      borderRadius: {
        default: 4,
        small: 4,
        medium: 6,
        large: 12,
        /** Use this border radius for pill shaped elements */
        full: 9999,
      },
    },
  },
  pattern: {
    size: {
      overlay: {
        height: {
          small: 256,
          medium: 320,
          large: 432,
          xlarge: 600,
        },
        width: {
          xsmall: 192,
          small: 320,
          medium: 480,
          large: 640,
          xlarge: 960,
        },
        borderRadius: 4,
        paddingBlock: {
          /** Vertical padding */
          condensed: 4,
          /** Vertical padding */
          normal: 12,
        },
        padding: {
          condensed: 8,
          normal: 16,
        },
        offset: 4,
      },
      control: {
        xsmall: {
          /** Vertical padding */
          paddingBlock: 2,
          paddingInline: {
            /** Horizontal Padding */
            condensed: 4,
            /** Horizontal Padding */
            normal: 8,
            /** Horizontal Padding */
            spacious: 12,
          },
          gap: 4,
          size: 24,
        },
        small: {
          paddingInline: {
            /** Horizontal Padding */
            condensed: 6,
            /** Horizontal Padding */
            normal: 8,
            /** Horizontal Padding */
            spacious: 12,
          },
          /** Vertical padding */
          paddingBlock: 4,
          gap: 4,
          size: 28,
        },
        medium: {
          /** Vertical padding */
          paddingBlock: 6,
          gap: 8,
          paddingInline: {
            /** Horizontal Padding */
            condensed: 8,
            /** Horizontal Padding */
            normal: 12,
            /** Horizontal Padding */
            spacious: 16,
          },
          size: 32,
        },
        large: {
          /** Vertical padding */
          paddingBlock: 10,
          paddingInline: {
            /** Horizontal Padding */
            condensed: 8,
            /** Horizontal Padding */
            normal: 12,
            /** Horizontal Padding */
            spacious: 16,
          },
          gap: 8,
          size: 40,
        },
        xlarge: {
          /** Vertical padding */
          paddingBlock: 14,
          gap: 8,
          paddingInline: {
            /** Horizontal Padding */
            condensed: 8,
            /** Horizontal Padding */
            normal: 12,
            /** Horizontal Padding */
            spacious: 16,
          },
          size: 48,
        },
      },
      controlStack: {
        small: {
          gap: {
            condensed: 4,
            normal: 8,
            spacious: 16,
          },
        },
        medium: {
          gap: {
            condensed: 4,
            normal: 8,
            spacious: 12,
          },
        },
        large: {
          gap: {
            condensed: 4,
            normal: 8,
            spacious: 12,
          },
        },
      },
      stack: {
        gap: {
          /** Layout gap space */
          condensed: 8,
          /** Layout gap space */
          normal: 16,
          /** Layout gap space */
          spacious: 24,
        },
        padding: {
          /** Layout padding */
          condensed: 8,
          /** Layout padding */
          normal: 16,
          /** Layout padding */
          spacious: 24,
        },
      },
      spinner: {
        size: {
          xlarge: 32,
          large: 20,
          medium: 16,
          small: 14,
          xsmall: 12,
        },
      },
      badge: {
        /** Vertical padding */
        paddingBlock: 2,
        /** Horizontal Padding */
        paddingInline: 2,
        gap: 4,
      },
    },
  },
  responsive: {
    xl: {
      breakpointScreen: {
        minWidth: 1440,
        maxWidth: 9999,
      },
      grid: {
        column: 12,
        gutter: 16,
        margin: 32,
        minWidth: 1440,
        maxWidth: 9999,
        fixedWideGrid: {
          maxWidth: 1296,
        },
        fixedNarrowGrid: {
          maxWidth: 864,
        },
      },
    },
    l: {
      breakpointScreen: {
        minWidth: 1024,
        maxWidth: 1440,
      },
      grid: {
        column: 12,
        gutter: 16,
        margin: 32,
        minWidth: 1440,
        maxWidth: 1439,
        fixedWideGrid: {
          maxWidth: 1296,
        },
        fixedNarrowGrid: {
          maxWidth: 864,
        },
      },
    },
    m: {
      breakpointScreen: {
        minWidth: 768,
        maxWidth: 1024,
      },
      grid: {
        column: 12,
        gutter: 16,
        margin: 32,
        minWidth: 1024,
        maxWidth: 1023,
        fixedWideGrid: {
          maxWidth: 1296,
        },
        fixedNarrowGrid: {
          maxWidth: 864,
        },
      },
    },
    s: {
      breakpointScreen: {
        minWidth: 480,
        maxWidth: 768,
      },
      grid: {
        column: 6,
        gutter: 12,
        margin: 16,
        minWidth: 768,
        maxWidth: 767,
        fixedWideGrid: {
          maxWidth: 1296,
        },
        fixedNarrowGrid: {
          maxWidth: 864,
        },
      },
    },
    xs: {
      breakpointScreen: {
        minWidth: 320,
        maxWidth: 480,
      },
      grid: {
        column: 2,
        gutter: 12,
        margin: 16,
        minWidth: 480,
        maxWidth: 479,
        fixedWideGrid: {
          maxWidth: 1296,
        },
        fixedNarrowGrid: {
          maxWidth: 864,
        },
      },
    },
  },
  theme: {
    light: {
      fgColor: {
        default: "#00344f",
        muted: "#5d5d5d",
        disabled: "#acacac",
        onEmphasis: "#ffffff",
        neutral: "#5d5d5d",
        accent: "#0d53a8",
        done: "#4430d5",
        closed: "#514634",
        danger: "#a01d18",
        severe: "#8c4607",
        attention: "#816f05",
        success: "#326d34",
        open: "#2c6059",
        black: "#000000",
        white: "#ffffff",
        onInverse: "#ffffff",
        link: "#832a80",
        linkOnEmphasis: "#fbfafb",
        primary: "#832a80",
        secondary: "#0078a2",
      },
      bgColor: {
        default: "#ffffff",
        muted: "#fbfbfb",
        inset: "#fbfbfb",
        disabled: "#eeeeee",
        emphasis: "#2e2e2e",
        transparent: "#ffffff00",
        inverse: "#464646",
        neutralEmphasis: "#5d5d5d",
        neutralMuted: "#eeeeee",
        accentEmphasis: "#0d53a8",
        accentMuted: "#e3f0ff",
        successEmphasis: "#326d34",
        successMuted: "#d5f6d3",
        openEmphasis: "#3b863d",
        openMuted: "#cce0dd",
        closedEmphasis: "#6c5e47",
        closedMuted: "#e3dacc",
        dangerEmphasis: "#a01d18",
        dangerMuted: "#fbe3df",
        severeEmphasis: "#8c4607",
        severeMuted: "#fce6d8",
        attentionEmphasis: "#816f05",
        attentionMuted: "#fcf8e8",
        doneEmphasis: "#4430d5",
        doneMuted: "#e5e8fb",
        black: "#000000",
        white: "#ffffff",
        backdrop: "#0000008c",
        primaryEmphasis: "#832a80",
        primaryMuted: "#f7edf7",
        secondaryEmphasis: "#0078a2",
        secondaryMuted: "#e0f3f8",
      },
      borderColor: {
        default: "#2222221f",
        muted: "#2222221a",
        emphasis: "#5d5d5d",
        disabled: "#7373731a",
        transparent: "#ffffff00",
        doneEmphasis: "#4430d5",
        doneMuted: "#4430d566",
        closedEmphasis: "#514634",
        closedMuted: "#51463466",
        dangerEmphasis: "#a01d18",
        dangerMuted: "#a01d1866",
        severeEmphasis: "#8c4607",
        severeMuted: "#8c460766",
        attentionEmphasis: "#816f05",
        attentionMuted: "#816f0566",
        successEmphasis: "#326d34",
        successMuted: "#3b863d66",
        accentEmphasis: "#0d53a8",
        accentMuted: "#0d53a866",
        openEmphasis: "#2c6059",
        openMuted: "#2c6059",
        translucent: "#ffffff26",
        primaryEmphasis: "#832a80",
        primaryMuted: "#832a8066",
        secondaryEmphasis: "#0078a2",
        secondaryMuted: "#0078a266",
      },
      role: {
        default: {
          outlined: {
            fgColor: {
              rest: "#5d5d5d",
              hover: "#2e2e2e",
              active: "#464646",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#dadada",
              active: "#c4c4c4",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#858585",
              hover: "#737373",
              active: "#464646",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#5d5d5d",
              hover: "#5d5d5d",
              active: "#5d5d5d",
              disabled: "#acacac",
            },
          },
          subtle: {
            fgColor: {
              rest: "#5d5d5d",
              hover: "#2e2e2e",
              active: "#464646",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#22222212",
              hover: "#2222222b",
              active: "#22222236",
              disabled: "#2222220d",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#5d5d5d",
              hover: "#2e2e2e",
              active: "#464646",
              disabled: "#acacac",
            },
          },
          bold: {
            bgColor: {
              rest: "#5d5d5d",
              hover: "#464646",
              active: "#2e2e2e",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#5d5d5d",
              hover: "#464646",
              active: "#2e2e2e",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
          },
        },
        accent: {
          outlined: {
            fgColor: {
              rest: "#0d53a8",
              hover: "#143e75",
              active: "#143e75",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#f7fafe",
              active: "#e3f0ff",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#0d53a8",
              hover: "#143e75",
              active: "#143e75",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#0d53a8",
              hover: "#143e75",
              active: "#143e75",
              disabled: "#acacac",
            },
          },
          subtle: {
            fgColor: {
              rest: "#0d53a8",
              hover: "#0d53a8",
              active: "#0d53a8",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#e3f0ff",
              hover: "#e3f0ff",
              active: "#c3deff",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#0d53a8",
              hover: "#0d53a8",
              active: "#0d53a8",
              disabled: "#acacac",
            },
          },
          bold: {
            bgColor: {
              rest: "#0d53a8",
              hover: "#143e75",
              active: "#143e75",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#0d53a8",
              hover: "#143e75",
              active: "#143e75",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
          },
        },
        attention: {
          outlined: {
            fgColor: {
              rest: "#816f05",
              hover: "#816f05cc",
              active: "#816f05",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#fcf8e8",
              active: "#f6ecb8",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#6a5b08",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#816f05",
              hover: "#816f05cc",
              active: "#816f05",
              disabled: "#acacac",
            },
          },
          subtle: {
            fgColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#816f05",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#fcf8e8",
              hover: "#f6ecb8",
              active: "#edd870",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#816f05",
              disabled: "#acacac",
            },
          },
          bold: {
            bgColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#6a5b08",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#6a5b08",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
          },
        },
        danger: {
          outlined: {
            fgColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#fbe3df",
              active: "#f9c7c0",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#acacac",
            },
          },
          subtle: {
            fgColor: {
              rest: "#a01d18",
              hover: "#a01d18",
              active: "#a01d18",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#fbe3df",
              hover: "#f9c7c0",
              active: "#f8a498",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#a01d18",
              hover: "#a01d18",
              active: "#a01d18",
              disabled: "#acacac",
            },
          },
          bold: {
            bgColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
          },
        },
        success: {
          outlined: {
            fgColor: {
              rest: "#326d34",
              hover: "#409d44",
              active: "#3b863d",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#d5f6d3",
              active: "#a7eda6",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#326d34",
              hover: "#409d44",
              active: "#3b863d",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#326d34",
              hover: "#409d44",
              active: "#3b863d",
              disabled: "#acacac",
            },
          },
          subtle: {
            fgColor: {
              rest: "#326d34",
              hover: "#326d34",
              active: "#326d34",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#d5f6d3",
              hover: "#a7eda6",
              active: "#80dc80",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#326d34",
              hover: "#326d34",
              active: "#326d34",
              disabled: "#acacac",
            },
          },
          bold: {
            bgColor: {
              rest: "#326d34",
              hover: "#3b863d",
              active: "#326d34",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#326d34",
              hover: "#3b863d",
              active: "#326d34",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
          },
        },
        severe: {
          outlined: {
            fgColor: {
              rest: "#8c4607",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#fce6d8",
              active: "#fbccaf",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#8c4607",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#8c4607",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#acacac",
            },
          },
          subtle: {
            fgColor: {
              rest: "#8c4607",
              hover: "#8c4607",
              active: "#8c4607",
              disabled: "#acacac",
            },
            bgColor: {
              rest: "#fce6d8",
              hover: "#fbccaf",
              active: "#faad79",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#8c4607",
              hover: "#8c4607",
              active: "#8c4607",
              disabled: "#acacac",
            },
          },
          bold: {
            bgColor: {
              rest: "#8c4607",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#eeeeee",
            },
            borderColor: {
              rest: "#8c4607",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac",
            },
          },
        },
      },
      surface: {
        overlay: {
          default: "#ffffff",
          hover: "#eeeeee",
          pressed: "#dadada",
        },
      },
      button: {
        primary: {
          borderColor: {
            rest: "#ffffff00",
            disabled: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
          },
          bgColor: {
            disabled: "#eeeeee",
            active: "#832a80",
            hover: "#6a2268",
            rest: "#832a80",
          },
          fgColor: {
            disabled: "#acacac",
            rest: "#ffffff",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac",
          },
        },
        secondary: {
          fgColor: {
            rest: "#832a80",
            disabled: "#acacac",
            active: "#832a80",
            hover: "#6a2268",
          },
          bgColor: {
            selected: "#ffffff00",
            active: "#832a801f",
            hover: "#832a801a",
            rest: "#ffffff00",
            disabled: "#ffffff00",
          },
          borderColor: {
            active: "#b57fb3",
            hover: "#ac6fa9",
            rest: "#debedc",
            disabled: "#7373731a",
          },
          iconColor: {
            hover: "#6a2268",
            rest: "#832a80",
            disabled: "#acacac",
          },
        },
        tertiary: {
          bgColor: {
            disabled: "#ffffff00",
            active: "#832a801f",
            hover: "#832a801a",
            rest: "#ffffff00",
          },
          fgColor: {
            active: "#832a80",
            hover: "#832a80",
            rest: "#832a80",
            disabled: "#acacac",
          },
          borderColor: {
            selected: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
            disabled: "#ffffff00",
          },
          iconColor: {
            hover: "#832a80",
            rest: "#832a80",
            disabled: "#acacac",
          },
        },
        neutral: {
          fgColor: {
            hover: "#5d5d5d",
            rest: "#5d5d5d",
            disabled: "#acacac",
            active: "#5d5d5d",
          },
          borderColor: {
            hover: "#ffffff00",
            rest: "#ffffff00",
            disabled: "#ffffff00",
          },
          bgColor: {
            active: "#c4c4c4",
            hover: "#dadada",
            rest: "#ffffff00",
            disabled: "#ffffff00",
          },
          iconColor: {
            hover: "#5d5d5d",
            rest: "#5d5d5d",
            disabled: "#acacac",
          },
        },
        danger: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#a01d18",
            hover: "#791b15",
            rest: "#a01d18",
            disabled: "#eeeeee",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac",
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#acacac",
            rest: "#ffffff",
          },
        },
        attention: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#dbc03a",
            hover: "#a48e10",
            rest: "#dbc03a",
            disabled: "#dbc03a26",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac",
          },
          fgColor: {
            active: "#816f05",
            hover: "#6a5b08",
            disabled: "#acacac",
            rest: "#816f05",
          },
        },
        success: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#3b863d",
            hover: "#326d34",
            rest: "#3b863d",
            disabled: "#3b863d26",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac",
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#acacac",
            rest: "#ffffff",
          },
        },
        accent: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#0d53a8",
            hover: "#143e75",
            rest: "#0d53a8",
            disabled: "#0d53a826",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac",
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#acacac",
            rest: "#ffffff",
          },
        },
        star: {
          iconColor: "#edd870",
        },
        inactive: {
          bgColor: "#eeeeee",
          fgColor: "#737373",
        },
      },
      focus: {
        outlineColor: "#832a80",
      },
    },
    dark: {
      fgColor: {
        default: "#f6f9fa",
        muted: "#c6c6c6",
        disabled: "#949494",
        onEmphasis: "#ffffff",
        neutral: "#c6c6c6",
        accent: "#529bff",
        done: "#808afc",
        closed: "#b6a283",
        danger: "#f75d4f",
        severe: "#d96e00",
        attention: "#b59c12",
        success: "#409d44",
        open: "#6da79f",
        black: "#000000",
        white: "#ffffff",
        onInverse: "#161616",
        link: "#b68cb5",
        linkOnEmphasis: "#f4f2f3",
        primary: "#b68cb5",
        secondary: "#4fb3cd",
      },
      bgColor: {
        default: "#161616",
        muted: "#1e1e1e",
        inset: "#161616",
        disabled: "#2c2c2c",
        emphasis: "#1e1e1e",
        transparent: "#ffffff00",
        inverse: "#dedede",
        neutralEmphasis: "#595959",
        neutralMuted: "#a0a0a01c",
        accentEmphasis: "#002e80",
        accentMuted: "#abc5ea0f",
        successEmphasis: "#255426",
        successMuted: "#b6eeb40f",
        openEmphasis: "#337635",
        openMuted: "#b4c8c40f",
        closedEmphasis: "#4f4432",
        closedMuted: "#d9cdba0f",
        dangerEmphasis: "#f75d4f",
        dangerMuted: "#f8cfc80f",
        severeEmphasis: "#622f03",
        severeMuted: "#f9cdb20f",
        attentionEmphasis: "#716104",
        attentionMuted: "#f9f3d40f",
        doneEmphasis: "#808afc",
        doneMuted: "#d2d8f90f",
        black: "#000000",
        white: "#ffffff",
        backdrop: "#0000008c",
        primaryEmphasis: "#832a80",
        primaryMuted: "#832a8024",
        secondaryEmphasis: "#0078a2",
        secondaryMuted: "#0078a224",
      },
      borderColor: {
        default: "#ffffff1f",
        muted: "#ffffff1a",
        emphasis: "#c6c6c6",
        disabled: "#7373731a",
        transparent: "#ffffff00",
        doneEmphasis: "#808afc",
        doneMuted: "#808afc66",
        closedEmphasis: "#b6a283",
        closedMuted: "#b6a28366",
        dangerEmphasis: "#f75d4f",
        dangerMuted: "#f75d4f66",
        severeEmphasis: "#d96e00",
        severeMuted: "#d96e0066",
        attentionEmphasis: "#b59c12",
        attentionMuted: "#cfb63366",
        successEmphasis: "#409d44",
        successMuted: "#33763566",
        accentEmphasis: "#529bff",
        accentMuted: "#529bff66",
        openEmphasis: "#6da79f",
        openMuted: "#6da79f66",
        translucent: "#16161626",
        primaryEmphasis: "#b68cb5",
        primaryMuted: "#a260a066",
        secondaryEmphasis: "#4fb3cd",
        secondaryMuted: "#0078a266",
      },
      role: {
        default: {
          outlined: {
            fgColor: {
              rest: "#c6c6c6",
              hover: "#f8f8f8",
              active: "#dedede",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#404040",
              active: "#595959",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#a0a0a0",
              hover: "#b2b2b2",
              active: "#dedede",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#c6c6c6",
              hover: "#c6c6c6",
              active: "#c6c6c6",
              disabled: "#949494",
            },
          },
          subtle: {
            fgColor: {
              rest: "#c6c6c6",
              hover: "#f8f8f8",
              active: "#dedede",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#ffffff12",
              hover: "#ffffff2b",
              active: "#ffffff36",
              disabled: "#ffffff0d",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#c6c6c6",
              hover: "#f8f8f8",
              active: "#dedede",
              disabled: "#949494",
            },
          },
          bold: {
            bgColor: {
              rest: "#595959",
              hover: "#dedede",
              active: "#f8f8f8",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#595959",
              hover: "#dedede",
              active: "#f8f8f8",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
          },
        },
        accent: {
          outlined: {
            fgColor: {
              rest: "#529bff",
              hover: "#001b4f",
              active: "#001b4f",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#f0f3f7",
              active: "#cddbed",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#529bff",
              hover: "#001b4f",
              active: "#001b4f",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#529bff",
              hover: "#001b4f",
              active: "#001b4f",
              disabled: "#949494",
            },
          },
          subtle: {
            fgColor: {
              rest: "#529bff",
              hover: "#529bff",
              active: "#529bff",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#abc5ea0f",
              hover: "#cddbed",
              active: "#abc5ea",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#529bff",
              hover: "#529bff",
              active: "#529bff",
              disabled: "#949494",
            },
          },
          bold: {
            bgColor: {
              rest: "#002e80",
              hover: "#001b4f",
              active: "#001b4f",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#002e80",
              hover: "#001b4f",
              active: "#001b4f",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
          },
        },
        attention: {
          outlined: {
            fgColor: {
              rest: "#b59c12",
              hover: "#514605cc",
              active: "#b59c12",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#f9f3d4",
              active: "#eedd89",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#b59c12",
              hover: "#716104",
              active: "#514605",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#b59c12",
              hover: "#514605cc",
              active: "#b59c12",
              disabled: "#949494",
            },
          },
          subtle: {
            fgColor: {
              rest: "#b59c12",
              hover: "#b59c12",
              active: "#b59c12",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#f9f3d40f",
              hover: "#eedd89",
              active: "#e0c852",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#b59c12",
              hover: "#b59c12",
              active: "#b59c12",
              disabled: "#949494",
            },
          },
          bold: {
            bgColor: {
              rest: "#716104",
              hover: "#716104",
              active: "#514605",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#716104",
              hover: "#716104",
              active: "#514605",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
          },
        },
        danger: {
          outlined: {
            fgColor: {
              rest: "#f75d4f",
              hover: "#e7000b",
              active: "#ae1411",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#f8cfc8",
              active: "#f7b1a6",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#f75d4f",
              hover: "#e7000b",
              active: "#ae1411",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#f75d4f",
              hover: "#e7000b",
              active: "#ae1411",
              disabled: "#949494",
            },
          },
          subtle: {
            fgColor: {
              rest: "#f75d4f",
              hover: "#f75d4f",
              active: "#f75d4f",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#f8cfc80f",
              hover: "#f7b1a6",
              active: "#f69386",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#f75d4f",
              hover: "#f75d4f",
              active: "#f75d4f",
              disabled: "#949494",
            },
          },
          bold: {
            bgColor: {
              rest: "#f75d4f",
              hover: "#e7000b",
              active: "#ae1411",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#f75d4f",
              hover: "#e7000b",
              active: "#ae1411",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
          },
        },
        success: {
          outlined: {
            fgColor: {
              rest: "#409d44",
              hover: "#409d44",
              active: "#337635",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#b6eeb4",
              active: "#8fe18f",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#409d44",
              hover: "#409d44",
              active: "#337635",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#409d44",
              hover: "#409d44",
              active: "#337635",
              disabled: "#949494",
            },
          },
          subtle: {
            fgColor: {
              rest: "#183819",
              hover: "#409d44",
              active: "#409d44",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#b6eeb40f",
              hover: "#8fe18f",
              active: "#76d177",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#183819",
              hover: "#409d44",
              active: "#409d44",
              disabled: "#949494",
            },
          },
          bold: {
            bgColor: {
              rest: "#337635",
              hover: "#337635",
              active: "#255426",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#337635",
              hover: "#337635",
              active: "#255426",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
          },
        },
        severe: {
          outlined: {
            fgColor: {
              rest: "#d96e00",
              hover: "#854204",
              active: "#622f03",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#f9cdb2",
              active: "#f7ad7d",
              disabled: "#ffffff00",
            },
            borderColor: {
              rest: "#d96e00",
              hover: "#854204",
              active: "#622f03",
              disabled: "#7373731a",
            },
            iconColor: {
              rest: "#d96e00",
              hover: "#854204",
              active: "#622f03",
              disabled: "#949494",
            },
          },
          subtle: {
            fgColor: {
              rest: "#d96e00",
              hover: "#d96e00",
              active: "#d96e00",
              disabled: "#949494",
            },
            bgColor: {
              rest: "#f9cdb20f",
              hover: "#f7ad7d",
              active: "#f39047",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00",
            },
            iconColor: {
              rest: "#d96e00",
              hover: "#d96e00",
              active: "#d96e00",
              disabled: "#949494",
            },
          },
          bold: {
            bgColor: {
              rest: "#622f03",
              hover: "#854204",
              active: "#622f03",
              disabled: "#2c2c2c",
            },
            borderColor: {
              rest: "#622f03",
              hover: "#854204",
              active: "#622f03",
              disabled: "#7373731a",
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#949494",
            },
          },
        },
      },
      surface: {
        overlay: {
          default: "#2c2c2c",
          hover: "#404040",
          pressed: "#1e1e1e",
        },
      },
      button: {
        primary: {
          borderColor: {
            rest: "#ffffff00",
            disabled: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
          },
          bgColor: {
            disabled: "#2c2c2c",
            active: "#832a80",
            hover: "#611f5f",
            rest: "#832a80",
          },
          fgColor: {
            disabled: "#949494",
            rest: "#ffffff",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#949494",
          },
        },
        secondary: {
          fgColor: {
            rest: "#b57fb3",
            disabled: "#949494",
            active: "#b68cb5",
            hover: "#91448f",
          },
          bgColor: {
            selected: "#ffffff00",
            active: "#a260a01f",
            hover: "#a260a01a",
            rest: "#ffffff00",
            disabled: "#ffffff00",
          },
          borderColor: {
            active: "#b57fb3",
            hover: "#a260a0",
            rest: "#bfa0bd",
            disabled: "#7373731a",
          },
          iconColor: {
            hover: "#91448f",
            rest: "#b57fb3",
            disabled: "#949494",
          },
        },
        tertiary: {
          bgColor: {
            disabled: "#ffffff00",
            active: "#a260a01f",
            hover: "#a260a01a",
            rest: "#ffffff00",
          },
          fgColor: {
            active: "#bfa0bd",
            hover: "#a260a0",
            rest: "#b57fb3",
            disabled: "#949494",
          },
          borderColor: {
            selected: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
            disabled: "#ffffff00",
          },
          iconColor: {
            hover: "#a260a0",
            rest: "#b57fb3",
            disabled: "#949494",
          },
        },
        neutral: {
          fgColor: {
            hover: "#c6c6c6",
            rest: "#c6c6c6",
            disabled: "#949494",
            active: "#c6c6c6",
          },
          borderColor: {
            hover: "#ffffff00",
            rest: "#ffffff00",
            disabled: "#ffffff00",
          },
          bgColor: {
            active: "#595959",
            hover: "#404040",
            rest: "#ffffff00",
            disabled: "#ffffff00",
          },
          iconColor: {
            hover: "#c6c6c6",
            rest: "#c6c6c6",
            disabled: "#949494",
          },
        },
        danger: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#7d1510",
            hover: "#55100c",
            rest: "#7d1510",
            disabled: "#2c2c2c",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#949494",
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#949494",
            rest: "#ffffff",
          },
        },
        attention: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#cfb633",
            hover: "#b59c12",
            rest: "#cfb633",
            disabled: "#cfb63326",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#949494",
          },
          fgColor: {
            active: "#716104",
            hover: "#514605",
            disabled: "#949494",
            rest: "#716104",
          },
        },
        success: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#337635",
            hover: "#255426",
            rest: "#337635",
            disabled: "#33763526",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#949494",
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#949494",
            rest: "#ffffff",
          },
        },
        accent: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00",
          },
          bgColor: {
            active: "#002e80",
            hover: "#004cb8",
            rest: "#002e80",
            disabled: "#002e8026",
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#949494",
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#949494",
            rest: "#ffffff",
          },
        },
        star: {
          iconColor: "#e0c852",
        },
        inactive: {
          bgColor: "#2c2c2c",
          fgColor: "#b2b2b2",
        },
      },
      focus: {
        outlineColor: "#b68cb5",
      },
    },
  },
  typography: {
    typography: {
      text: {
        display: {
          fontWeight: 600,
          fontFamily: "Montserrat",
          fontSize: 43,
          /** base.typography.text.lineHeight.snug */
          lineHeight: 1.375,
          letterSpacing: -0.2,
        },
        title: {
          lineHeight: {
            /** base.typography.text.lineHeight.normal */
            xsmall: 1.5,
            /** base.typography.text.lineHeight.normal */
            small: 1.5,
            /** base.typography.text.lineHeight.relaxed */
            medium: 1.625,
            /** base.typography.text.lineHeight.normal */
            large: 1.5,
          },
          fontSize: {
            xsmall: 14,
            small: 18,
            medium: 22,
            large: 27,
          },
          fontWeight: {
            xsmall: 500,
            small: 600,
            medium: 600,
            large: 600,
          },
          letterSpacing: {
            xsmall: 0,
            small: -0.2,
            medium: -0.2,
            large: -0.2,
          },
        },
        body: {
          fontWeight: 400,
          fontSize: {
            /** Base text */
            small: 12,
            /** Base text */
            medium: 14,
            /** Base text */
            large: 18,
          },
          lineHeight: {
            /** base.typography.text.lineHeight.relaxed */
            small: 1.625,
            /** base.typography.text.lineHeight.normal */
            medium: 1.5,
            /** base.typography.text.lineHeight.normal */
            large: 1.5,
          },
          letterSpacing: {
            /** Base text */
            small: 0,
            /** Base text */
            medium: 0,
            /** Base text */
            large: 0,
          },
        },
        monospace: {
          fontFamily: "Inconsolata",
          fontWeight: 400,
          fontSize: {
            /** Base text */
            small: 12,
            /** Base text */
            medium: 14,
            /** Base text */
            large: 18,
          },
          lineHeight: {
            /** base.typography.text.lineHeight.normal */
            small: 1.5,
            /** base.typography.text.lineHeight.normal */
            medium: 1.5,
            /** base.typography.text.lineHeight.normal */
            large: 1.5,
          },
          letterSpacing: {
            /** Base text */
            small: 0,
            /** Base text */
            medium: 0,
            /** Base text */
            large: 0,
          },
        },
        caption: {
          fontWeight: 400,
          fontSize: 12,
          /** base.typography.text.lineHeight.tight */
          lineHeight: 1.25,
          letterSpacing: 0.3,
        },
        overline: {
          fontFamily: "Montserrat",
          fontWeight: 400,
          fontSize: 14,
          /** base.typography.text.lineHeight.normal */
          lineHeight: 1.5,
          letterSpacing: 1,
        },
        subtitle: {
          fontSize: {
            medium: 22,
            small: 18,
          },
          fontWeight: {
            medium: 500,
            small: 500,
          },
          letterSpacing: {
            medium: 0,
            small: 0,
          },
          lineHeight: {
            /** base.typography.text.lineHeight.normal */
            medium: 1.5,
            /** base.typography.text.lineHeight.normal */
            small: 1.5,
          },
        },
      },
    },
  },
};

export default tokens;
